(function(){
  'use strict';

  // ───────── REVEAL ON SCROLL ─────────
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function(el){ observer.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('visible'); });
  }

  // ───────── SMOOTH SCROLL ─────────
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    // Skip the moon trigger — it has its own click handler
    if (link.id === 'moon-trigger') return;
    link.addEventListener('click', function(e){
      var id = link.getAttribute('href');
      if (id.length <= 1) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ───────── EASTER EGG: JUMPER FLY-ACROSS ─────────
  var moonTrigger = document.getElementById('moon-trigger');
  var jumper = document.getElementById('jumper');
  var isFlying = false;
  var audioCtx = null;

  // Lazily create AudioContext (browsers require user gesture before audio)
  function getAudioCtx() {
    if (!audioCtx) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (Ctx) audioCtx = new Ctx();
    }
    return audioCtx;
  }

  // Whoosh: filtered noise that sweeps in pitch/volume
  function playWhoosh() {
    var ctx = getAudioCtx();
    if (!ctx) return;
    var now = ctx.currentTime;
    var duration = 1.4;

    // Generate white noise buffer
    var bufferSize = Math.floor(ctx.sampleRate * duration);
    var buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < bufferSize; i++) {
      data[i] = (Math.random() * 2 - 1) * 0.5;
    }

    var source = ctx.createBufferSource();
    source.buffer = buffer;

    // Bandpass filter sweep — gives the "whoosh by" feel
    var filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.Q.value = 1.2;
    filter.frequency.setValueAtTime(200, now);
    filter.frequency.exponentialRampToValueAtTime(1800, now + 0.5);
    filter.frequency.exponentialRampToValueAtTime(400, now + duration);

    // Volume envelope — rise, sustain, fall (mimics doppler pass-by)
    var gain = ctx.createGain();
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.35, now + 0.3);
    gain.gain.linearRampToValueAtTime(0.4, now + 0.7);
    gain.gain.exponentialRampToValueAtTime(0.001, now + duration);

    source.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    source.start(now);
    source.stop(now + duration);
  }

  // Splash: low thump + high noise burst (water break + spray)
  function playSplash() {
    var ctx = getAudioCtx();
    if (!ctx) return;
    var now = ctx.currentTime;

    // ── Low thump (the body hitting water)
    var thump = ctx.createOscillator();
    thump.type = 'sine';
    thump.frequency.setValueAtTime(120, now);
    thump.frequency.exponentialRampToValueAtTime(40, now + 0.2);
    var thumpGain = ctx.createGain();
    thumpGain.gain.setValueAtTime(0.5, now);
    thumpGain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);
    thump.connect(thumpGain);
    thumpGain.connect(ctx.destination);
    thump.start(now);
    thump.stop(now + 0.3);

    // ── Splash noise (water spray / droplets)
    var splashDur = 0.6;
    var bufSize = Math.floor(ctx.sampleRate * splashDur);
    var buf = ctx.createBuffer(1, bufSize, ctx.sampleRate);
    var d = buf.getChannelData(0);
    for (var i = 0; i < bufSize; i++) {
      d[i] = (Math.random() * 2 - 1);
    }

    var splash = ctx.createBufferSource();
    splash.buffer = buf;

    // Highpass to give it that splashy "wet" quality
    var hp = ctx.createBiquadFilter();
    hp.type = 'highpass';
    hp.frequency.setValueAtTime(1200, now);
    hp.frequency.exponentialRampToValueAtTime(400, now + splashDur);

    var splashGain = ctx.createGain();
    splashGain.gain.setValueAtTime(0, now);
    splashGain.gain.linearRampToValueAtTime(0.4, now + 0.02);
    splashGain.gain.exponentialRampToValueAtTime(0.001, now + splashDur);

    splash.connect(hp);
    hp.connect(splashGain);
    splashGain.connect(ctx.destination);
    splash.start(now);
    splash.stop(now + splashDur);
  }

  function flyJumper() {
    if (isFlying || !jumper) return;
    isFlying = true;

    // Resume audio context if suspended (Safari/iOS requirement)
    var ctx = getAudioCtx();
    if (ctx && ctx.state === 'suspended') {
      ctx.resume();
    }

    // Whoosh starts immediately as the figure enters
    playWhoosh();

    // Trigger animation
    jumper.classList.add('flying');

    // Splash ~1.5s in, just before he exits the left edge (animation is 1.8s total)
    setTimeout(playSplash, 1500);

    // Cleanup after animation completes
    setTimeout(function(){
      jumper.classList.remove('flying');
      isFlying = false;
    }, 1850);
  }

  if (moonTrigger) {
    moonTrigger.addEventListener('click', function(e){
      e.preventDefault();
      flyJumper();
    });
  }
})();
